/**
 * Copyright 2016 xdot GmbH
 *
 * Author: Marius Runde
 * Date: 02.06.2016
 *
 */
'use strict';

import React from 'external/react';
import PropTypes from 'external/prop-types';
import { FormControl, FormGroup, FormLabel, Container } from 'external/react-bootstrap';
import { DataUtil, Title, ValidationMessage, } from 'plugin/liferay-widgets-react-web';

class DefaultMapConfigEditForm extends React.Component {

    constructor(props){
        super(props);
    }

    componentDidMount(){
        const { formData } = this.props;
        return this.props.onChange(formData, this.validate(formData));
    }

    onMapConfigChange(e){
        this.handleChange({
            ...this.props.formData,
            mapConfigId: e.target.value
        });
    }

    handleChange(formData){
        this.props.onChange(formData, this.validate(formData));
    }

    validate(formData){
        let mapConfigIdValid;

        if (!(formData.mapConfigId > 0)) {
            mapConfigIdValid = 'Bitte Standardkonfiguration auswählen.';
        }

        return {
            mapConfigId: mapConfigIdValid
        };
    }

    render(){
        const { formData, formValidation } = this.props;
        const mapConfigs = DataUtil.asArray(this.props.mapConfigs);

        let options = mapConfigs && mapConfigs.length > 0 ? mapConfigs.map(mapConfig => {
            return (<option key={'DefaultMapConfigOption_' + mapConfig.id}
                            value={mapConfig.id}>{mapConfig.title}</option>);
        }) : [];

        options.unshift((<option key={'DefaultMapConfigOption_' + -1}
                                 value={-1}>Bitte wählen</option>));

        return (
            <Container className="py-3">
                <Title title="Standardkartenkonfiguration wählen"/>
                <FormGroup controlId="formControlsSelect">
                    <FormLabel>Standardkartenkonfiguration</FormLabel>
                    <FormControl as="select"
                                 value={formData.mapConfigId || -1}
                                 onChange={this.onMapConfigChange.bind(this)}>
                        {options}
                    </FormControl>
                    <ValidationMessage formValidation={formValidation} propName="mapConfigId"/>
                </FormGroup>
            </Container>
        );
    }
}

DefaultMapConfigEditForm.propTypes = {
    formData: PropTypes.object,
    mapConfigs: PropTypes.object,
    formValidation: PropTypes.object,
    onChange: PropTypes.func
};

export default DefaultMapConfigEditForm;



// WEBPACK FOOTER //
// ./js/components/DefaultMapConfigEditForm.jsx